// (function () {
// 	const initProductAccordion = () => {
// 		$(".about__accordion-title").click(function () {
// 			if (!$(this).hasClass("active")) {
// 				$(".about__accordion-title.active").removeClass("active");
// 				$(this).addClass("active");
// 				$(".about__accordion-description").stop().slideUp(300);
// 				$(this)
// 					.siblings(".about__accordion-description")
// 					.eq($(this).index())
// 					.stop()
// 					.slideDown(300);
// 			} else {
// 				$(this).removeClass("active");
// 				$(this).siblings(".about__accordion-description").stop().slideUp(300);
// 			}
// 		});
// 	};

// 	document.addEventListener("shopify:section:load", function () {
// 		initProductAccordion();
// 	});

// 	initProductAccordion();
// })();



(function () {
	// Store initialized elements to prevent duplicate event listeners
	const initializedTitles = new WeakSet();

	const slideUp = (element, duration = 300) => {
		element.style.height = element.scrollHeight + "px";
		element.offsetHeight; // Force reflow
		element.style.transitionProperty = "height, opacity";
		element.style.transitionDuration = duration + "ms";
		element.style.height = "0";
		element.style.opacity = "0";
		element.style.overflow = "hidden";
		
		setTimeout(() => {
			element.style.display = "none";
		}, duration);
	};

	const slideDown = (element, duration = 300) => {
		element.style.display = "block";
		element.style.height = "0";
		element.style.opacity = "0";
		element.style.overflow = "hidden";
		element.offsetHeight; // Force reflow
		
		const height = element.scrollHeight;
		element.style.transitionProperty = "height, opacity";
		element.style.transitionDuration = duration + "ms";
		element.style.height = height + "px";
		element.style.opacity = "1";
		
		setTimeout(() => {
			element.style.height = "";
			element.style.overflow = "";
			element.style.transitionProperty = "";
			element.style.transitionDuration = "";
		}, duration);
	};

	const initProductAccordion = () => {
		const titles = document.querySelectorAll(".about__accordion-title");
		
		titles.forEach(title => {
			// Skip if already initialized
			if (initializedTitles.has(title)) {
				return;
			}
			
			// Mark as initialized
			initializedTitles.add(title);
			
			title.addEventListener("click", function (e) {
				e.preventDefault();
				e.stopPropagation();
				
				// Find the corresponding description
				const description = this.nextElementSibling;
				
				// Verify it's the correct element
				if (!description || !description.classList.contains("about__accordion-description")) {
					console.error("Description element not found for:", this);
					return;
				}
				
				const isActive = this.classList.contains("active");
				
				if (!isActive) {
					// Close all other accordions
					const allTitles = document.querySelectorAll(".about__accordion-title.active");
					allTitles.forEach(activeTitle => {
						if (activeTitle !== this) {
							activeTitle.classList.remove("active");
							const activeDesc = activeTitle.nextElementSibling;
							if (activeDesc && activeDesc.classList.contains("about__accordion-description")) {
								slideUp(activeDesc, 300);
							}
						}
					});
					
					// Open this accordion
					this.classList.add("active");
					slideDown(description, 300);
				} else {
					// Close this accordion
					this.classList.remove("active");
					slideUp(description, 300);
				}
			});
		});
	};

	// Initialize on Shopify section load
	document.addEventListener("shopify:section:load", function (e) {
		console.log("Shopify section loaded:", e.detail);
		setTimeout(initProductAccordion, 100);
	});

	// Initialize on DOM ready
	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", initProductAccordion);
	} else {
		initProductAccordion();
	}
})();
